import { StoreState } from '@/redux/types';

export const selectBasket = (state: StoreState) => state.basket.data;
